import React, { useState, Fragment, useEffect } from "react";
import styles from "./Category.module.css";
import {
  Row,
  Button,
  Col,
  Card,
  Input,
  Modal,
  Radio,
  Select,
  Space,
  Spin,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { CloudDownloadOutlined, SearchOutlined } from "@ant-design/icons";
import { fetchUserVal, fetchJsData } from "../../../../api";
import { crawl, getArrDists, reduceMap } from "../../../../api/util";
import { CSVLink } from "react-csv";
const { Text } = Typography;
const { Search } = Input;

const { Option } = Select;

const fetchCatAct = async (rel) => {
  const data = await fetchJsData({
    type: "fetch",
    qry: "fetCatAct",
    preProcess: true,
    preProcFunc: "arrayGen",
    firstVal: rel,
    secondVal: rel,
    thirdVal: rel,
  });
  return data;
};

const fetchUserSearch = async (usrRel, app) => {
  const data = await fetchUserVal("fetCatMod", {
    firstVal: usrRel,
    secondVal: usrRel,
    thirdVal: app,
  });
  return data;
};

let WEBCAT = [];
export const FetchTabSearch = (props) => {
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const [statData, setStatData] = useState([]);
  const [dropData, setDropData] = useState([]);
  const [origData, setOrigData] = useState({});
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);
  const [app, setApp] = useState("");
  const [trig, setTrig] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selValue, setSelValue] = useState([]);
  const [value, setValue] = useState("crawl");
  const [actActionModal, setActActionModal] = useState(false);
  const [selAct, setSelAct] = useState("");
  const [activeTab, setActiveTab] = useState("1");

  const tabKey = { 1: "app", 2: "web" };

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [props.submit]);

  const fetchData = async () => {
    const { data: users } = await fetchCatAct(props.usrRel);
    const { data: cat } = await fetchJsData({
      type: "fetch",
      qry: "fetWebCat",
      preProcess: false,
      firstVal: props.usrRel,
    });
    WEBCAT = cat.map((i) => {
      return {
        id: i.category_id,
        app: i.category_name,
        activity:
          "Download, Post, Upload, Login Attempt, Browse, Like, Dislike, Subscribe, Unsubscribe, FormPost",
      };
    });
    setOrigData({ app: users, web: WEBCAT });
    setFilteredData(users);
    setSelectData(users);
    setStatData(users);
    setDropData(getArrDists(users.map((x) => x.activity.split(", "))));
    const searchInd = users.map((user) => {
      const allValues = crawl(user);
      return { allValues: allValues.toString() };
    });
    setSearchIndex(searchInd);
    setActiveTab("1");
    if (users) setLoading(false);
    setValue("crawl");
    setValue("act");
  };

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[tabKey[activeTab]][index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData[tabKey[activeTab]]);
  }, [searchVal, origData, searchIndex, props.submit]);

  const ColOwn = [
    {
      title: () => {
        return (
          <>
            Category Name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">
                {value !== "act" ? filteredData.length : selectData.length}
              </Tag>
            )}
          </>
        );
      },
      dataIndex: "app",
      key: "app",
      fixed: "left",
      width: "20%",
      sorter: (a, b) => (a.app ? a.app.localeCompare(b.app) : 1),
      render: (text, record) => (
        <Space size="middle">
          <a
            onClick={() => {
              setApp(record.app);
              setOpenModal(true);
              setActActionModal(false);
              setTrig(!trig);
            }}
          >
            {record.app}
          </a>
        </Space>
      ),
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      fixed: "left",
      width: "89%",
      render: (text, record) => (
        <>
          {text.split(", ").map(function (item, i) {
            return (
              <a
                className={styles.clickablelink}
                onClick={() => {
                  setApp(record.app);
                  setSelAct(item);
                  setActActionModal(true);
                  setOpenModal(false);
                  setTrig(!trig);
                }}
              >
                {item}
                {text.split(", ").length - 1 == i ? "" : ", "}
              </a>
            );
          })}
        </>
      ),
    },
  ];

  const ColOnlyWeb = [
    {
      title: () => {
        return (
          <>
            Category Name{" "}
            {loading ? (
              <Spin size="small" />
            ) : (
              <Tag color="processing">
                {value !== "act" ? filteredData.length : selectData.length}
              </Tag>
            )}
          </>
        );
      },
      dataIndex: "app",
      key: "app",
      fixed: "left",
      width: "20%",
      sorter: (a, b) => (a.app ? a.app.localeCompare(b.app) : 1),
    },
    {
      title: "Activity",
      dataIndex: "activity",
      key: "activity",
      fixed: "left",
      width: "89%",
      render: (text, record) => (
        <>
          {text.split(", ").map(function (item, i) {
            return (
              <a
                className={styles.clickablelink}
                onClick={() => {
                  setApp(record.app);
                  setSelAct(item);
                  setActActionModal(true);
                  setOpenModal(false);
                  setTrig(!trig);
                }}
              >
                {item}
                {text.split(", ").length - 1 == i ? "" : ", "}
              </a>
            );
          })}
        </>
      ),
    },
  ];

  function handleChange(value) {
    setSelValue(value);
    setSelectData(
      filteredData.filter((x) => reduceMap(value, x.activity.split(", ")))
    );
  }

  const onRadioChange = (e) => {
    setSearchVal("");
    setValue(e.target.value);
    setSelectData(statData);
  };

  const tablePro = {
    rowKey: "id",
    size: "small",
    bordered: true,
    scroll: { x: 550, y: 900 },
    style: { margin: "2px" },
    pagination: {
      pageSizeOptions: ["10", "30", "60", "100", "1000"],
      defaultPageSize: ["50"],
      showSizeChanger: true,
    },
  };

  const onTabChange = (activeKey) => {
    setActiveTab("" + activeKey);
    setSelectData(origData[tabKey[activeKey]]);
    setStatData(origData[tabKey[activeKey]]);
    setDropData(
      getArrDists(
        origData[tabKey[activeKey]].map((x) => x.activity.split(", "))
      )
    );
    const searchInd = origData[tabKey[activeKey]].map((user) => {
      return { allValues: crawl(user).toString() };
    });
    setSearchIndex(searchInd);
  };

  return (
    <>
      <div>
        <Row gutter={16}>
          <Col className="gutter-row" span={1}></Col>
          <Col span={22}>
            <Card
              title={"Release - " + props.usrRel.split('snapshot_v')[1].split('_')[0]}
              size="small"
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
              extra={
                <>
                  {loading ? (
                    <div>
                      <Spin size="small" />
                    </div>
                  ) : (
                    <Space>
                      <Radio.Group onChange={onRadioChange} value={value}>
                        <Radio value="act">Activity Filter</Radio>
                        <Radio value="crawl">Crawl Filter</Radio>
                      </Radio.Group>

                      {value !== "act" ? (
                        <Input
                          onChange={(e) => setSearchVal(e.target.value)}
                          prefix={
                            <SearchOutlined className="site-form-item-icon" />
                          }
                          placeholder="Crawl Search"
                          allowClear
                          style={{ width: "100%" }}
                        />
                      ) : (
                        <Select
                          mode="multiple"
                          size="Default"
                          allowClear
                          placeholder="Filter Activities"
                          defaultValue={[]}
                          onChange={handleChange}
                          style={
                            selValue.length <= 3
                              ? { width: "40%" }
                              : selValue.length <= 6
                              ? { width: "70%" }
                              : selValue.length >= 9
                              ? { width: "95%" }
                              : {}
                          }
                          style={{ width: "220px" }}
                        >
                          {dropData.map((x) => (
                            <Option key={x}>{x}</Option>
                          ))}
                        </Select>
                      )}

                      <Tooltip
                        placement="topRight"
                        title="Download Category Report"
                        arrowPointAtCenter
                      >
                        <CSVLink
                          filename={"Category Report.csv"}
                          data={value !== "act" ? filteredData : selectData}
                          className="btn btn-primary"
                        >
                          <CloudDownloadOutlined style={{ fontSize: "29px" }} />
                        </CSVLink>
                      </Tooltip>
                    </Space>
                  )}
                </>
              }
            >
              <Fragment>
                <Tabs onChange={onTabChange} activeKey={activeTab}>
                  <Tabs.TabPane tab={"Application Categories"} key="1">
                    <Table
                      {...tablePro}
                      dataSource={value !== "act" ? filteredData : selectData}
                      columns={ColOwn}
                      loading={loading}
                    />
                  </Tabs.TabPane>
                  <Tabs.TabPane tab={"Only Web Categories"} key="2">
                    <Table
                      {...tablePro}
                      dataSource={value !== "act" ? filteredData : selectData}
                      columns={ColOnlyWeb}
                      loading={loading}
                    />
                  </Tabs.TabPane>
                </Tabs>
              </Fragment>
              <Fragment>
                <OpenMod
                  usrRel={props.usrRel}
                  rel={props.rel}
                  app={app}
                  openModal={openModal}
                  trig={trig}
                />
                <ActActionModal
                  usrRel={props.usrRel}
                  rel={props.rel}
                  modalTitle={selAct}
                  category={app}
                  actActionModal={actActionModal}
                  trig={trig}
                />
              </Fragment>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

// Modal Popup Window
const OpenMod = (props) => {
  const [app, setApp] = useState(props.app);
  const [searchVal, setSearchVal] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [searchIndex, setSearchIndex] = useState([]);
  const [loading, setLoading] = useState(true);

  const [show, setShow] = useState(false);
  const openModal = () => setShow(props.openModal);
  const closeModal = () => {
    setSearchVal("");
    setShow(false);
  };

  useEffect(() => {
    setLoading(true);
    const crawl = (user, allValues) => {
      if (!allValues) allValues = [];
      for (var key in user) {
        if (typeof user[key] === "object") crawl(user[key], allValues);
        else allValues.push(user[key] + " ");
      }
      return allValues;
    };
    const fetchDatas = async () => {
      const { data: users } = await fetchUserSearch(props.usrRel, props.app);
      setOrigData(users);
      setFilteredData(users);
      const searchInd = users.map((user) => {
        const allValues = crawl(user);
        return { allValues: allValues.toString() };
      });
      setSearchIndex(searchInd);
      if (users) setLoading(false);
    };
    if (props.openModal === true) {
      fetchDatas();
    }
  }, [props.app]);

  useEffect(() => {
    if (searchVal) {
      const reqData = searchIndex.map((user, index) => {
        if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0)
          return origData[index];
        return null;
      });
      setFilteredData(
        reqData.filter((user) => {
          if (user) return true;
          return false;
        })
      );
    } else setFilteredData(origData);
  }, [searchVal, origData, searchIndex, props.app]);

  useEffect(() => {
    setApp(props.app);
    if (props.openModal === true) {
      openModal();
    }
  }, [props.trig]);

  const renderContent = (value, row, index) => {
    let tagValue;

    if (value.toLowerCase().trim() === "own") {
      tagValue = "App Connector";
    } else if (value.toLowerCase().trim() === "uc") {
      tagValue = "CASB Universal Connector";
    } else {
      tagValue = value;
    }
    return <>{tagValue}</>;
  };

  const ColOwn = [
    {
      title: () => {
        return (
          <>
            Application Name{" "}
            {loading ? (
              <div>
                <Spin size="small" />
              </div>
            ) : (
              <Tag color="processing">{filteredData.length}</Tag>
            )}
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      width: "60%",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
    },
    {
      title: "Connector Type",
      dataIndex: "connector_support",
      key: "connector_support",
      fixed: "left",
      width: "40%",
      sorter: (a, b) =>
        a.connector_support
          ? a.connector_support.localeCompare(b.connector_support)
          : 1,
      render: renderContent,
    },
  ];

  return (
    <Modal
      title={
        loading ? (
          <div>
            <Spin size="small" />
          </div>
        ) : (
          <Text keyboard>
            <>{app}</>
          </Text>
        )
      }
      visible={show}
      onOk={closeModal}
      confirmLoading={loading}
      onCancel={closeModal}
      width={700}
    >
      <Card
        className={styles.chart}
        size="small"
        headStyle={{ backgroundColor: "#F0F8FF", border: 2 }}
        extra={
          <Row>
            <Col span={21}>
              <Input
                value={searchVal}
                onChange={(e) => {
                  setSearchVal(e.target.value);
                }}
                prefix={<SearchOutlined className="site-form-item-icon" />}
                placeholder="Crawl Search"
                allowClear
              />
            </Col>
            <Col span={1}></Col>
            <Col className="gutter-row" span={2}>
              {" "}
              <div>
                {loading ? (
                  <div>
                    <Spin size="small" />
                  </div>
                ) : (
                  <Tooltip
                    placement="topRight"
                    title={app + " Report"}
                    arrowPointAtCenter
                  >
                    <CSVLink
                      filename={app + "Report.csv"}
                      data={filteredData}
                      className="btn btn-primary"
                    >
                      <CloudDownloadOutlined style={{ fontSize: "29px" }} />
                    </CSVLink>
                  </Tooltip>
                )}
              </div>
            </Col>
          </Row>
        }
        bordered={true}
        loading={loading}
      >
        <Fragment>
          <Table
            rowKey="application_id"
            size="small"
            bordered
            scroll={{ x: 550, y: 900 }}
            style={{ margin: "2px" }}
            dataSource={filteredData}
            columns={ColOwn}
            loading={loading}
            pagination={{
              pageSizeOptions: ["10", "30", "60", "100", "1000"],
              showSizeChanger: true,
            }}
          />
        </Fragment>
      </Card>
    </Modal>
  );
};

const ActActionModal = (props) => {
  const [modalTitle, setModalTitle] = useState(props.modalTitle);
  const [loading, setLoading] = useState(true);
  const [origData, setOrigData] = useState([]);
  const [show, setShow] = useState(false);

  const ColActAction = [
    {
      title: "Profile",
      dataIndex: "profile",
      key: "profile",
      fixed: "left",
      width: "10%",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
  ];

  const openModal = () => setShow(props.actActionModal);
  const closeModal = () => setShow(false);

  useEffect(() => {
    setLoading(true);
    const fetchActAction = async () => {
      const { data: catActAction } = await fetchJsData({
        type: "fetch",
        qry: "fetConCatActAction",
        preProcess: true,
        preProcFunc: "catActConAction",
        firstVal: props.usrRel,
        secondVal: props.usrRel,
        thirdVal: props.usrRel,
        fourthVal: props.category,
        fifthVal: props.modalTitle,
      });
      setOrigData(catActAction.catActAction);
      if (catActAction.catActAction) setLoading(false);
    };
    if (props.actActionModal === true) {
      fetchActAction();
    }
  }, [props.modalTitle, props.category]);

  useEffect(() => {
    setModalTitle(props.modalTitle);
    if (props.actActionModal === true) {
      openModal();
    }
  }, [props.trig]);

  return (
    <Modal
      title={
        loading ? (
          <div>
            <Spin size="small" />
          </div>
        ) : (
          <Text keyboard>
            {props.category} {"-> "} {modalTitle}
          </Text>
        )
      }
      visible={show}
      onOk={closeModal}
      confirmLoading={loading}
      onCancel={closeModal}
      width="50%"
    >
      <Card size="small" bordered={true} loading={loading}>
        <Table
          size="small"
          bordered
          columns={ColActAction}
          loading={loading}
          dataSource={origData}
          pagination={false}
        />
      </Card>
    </Modal>
  );
};
